import { ArrowRight, Check, Gauge, ScanSearch, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { LessonDay } from '../content/types';

export function RevisionCard({ lesson, compact = false }: { lesson: LessonDay; compact?: boolean }) {
  const isPattern = lesson.track === 'DSA' || lesson.day === 59;
  return (
    <article className={`revision-card phase-${lesson.phaseNumber} ${compact ? 'compact' : ''}`}>
      <header>
        <div><span>{isPattern ? <ScanSearch /> : <Sparkles />}</span><div><small>{lesson.revision.label}</small><b>{lesson.title}</b></div></div>
        <em>DAY {String(lesson.day).padStart(2, '0')}</em>
      </header>
      <div className="identifier-box"><small>{isPattern ? 'WHEN YOU SEE' : 'CORE DECISION'}</small><p>{lesson.revision.identifier}</p></div>
      <ul>{lesson.revision.bullets.map((bullet) => <li key={bullet}><Check /><span>{bullet}</span></li>)}</ul>
      <footer>
        {lesson.revision.complexity ? <span><Gauge /> {lesson.revision.complexity}</span> : <span>{lesson.phase}</span>}
        {!compact && <Link to={`/day/${lesson.day}`}>Open lesson <ArrowRight /></Link>}
      </footer>
    </article>
  );
}

